module.exports = __webpack_public_path__ + "assets/icon-forum-component.1a345b31.svg";